import client from "services/ngage/api-client";
import {OperatorSettings, OperatorSettingsData} from "types/Operator";

/**
 * Get current operator settings
 */
const get = async () => {
    const response = await client.get<OperatorSettings>('/settings/')
    return response.data
}

/**
 * Update operator settings
 *
 * @param data
 */
const update = async (data: OperatorSettingsData) => {
    const response = await client.put<OperatorSettings>('/settings', data)
    return response.data
}

const settings = {
    get,
    update
}

export default settings;